const CaymanDedicatedServices = [
  {
    title: 'Pay & Go Answering Service',
    subTitle: 'This package include 100 minutes per month, additional billed at 25¢',
    features: [
      'Dedicated 345 Phone Numbers',
      'Customized Call Handling',
      'Mon-Fri 8:30-5:00pm',
      'General FAQ Provided',
      'Online Access to Messages',
      'Message Notification',
      'After Hours Voice-mail to Email',
      'Hoax Calls Free',
    ],
    price: 'US$150.00',
    duration: 'per month',
    type: 'cayman',
    subtype: 'CAYMAN1',
  },
  {
    title: '250 Minutes Package',
    subTitle:
      'Includes 250 calling minutes and 120 call patching minutes per month. Additional billed at 20¢',
    features: [
      'Dedicated 345 Phone Numbers',
      'Customized Call Handling',
      'Mon-Fri 8:30-5:00pm',
      'General FAQ Provided',
      'Online Access to Messages',
      'Message Notification',
      'After Hours Voice-mail to Email',
      'Hoax Calls Free',
      '120 Call Patch / Transfer Minutes',
    ],
    price: 'US$250.00',
    duration: 'per month',
    type: 'cayman',
    subtype: 'CAYMAN2',
  },
  {
    title: '500 Minutes Package',
    subTitle:
      'Includes 500 calling minutes and 200 call patching minutes per month. Additional billed at 10¢',
    features: [
      'Dedicated 345 Phone Numbers',
      'Customized Call Handling',
      'Mon-Fri 8:30-5:00pm',
      'General FAQ Provided',
      'Online Access to Messages',
      'Message Notification',
      'After Hours Voice-mail to Email',
      'Hoax Calls Free',
      '200 Call Patch / Transfer Minutes',
    ],
    price: 'US$300.00',
    duration: 'per month',
    type: 'cayman',
    subtype: 'CAYMAN3',
  },
]

export default CaymanDedicatedServices
